import React from 'react'
import loadingBox from '../../assets/images/loading_box.gif'
import { ErrorMessage, Field, Form, Formik, FormikActions } from 'formik'
import * as Yup from 'yup'
import { ITSError } from '../Layout/ITSError'

interface ResetTemporaryPasswordValues {
  password: string
  passwordconfirmation: string
}

const ResetTemporaryPasswordValidationSchema = Yup.object().shape({
  password: Yup.string()
    .required('Password is required')
    .min(
      8,
      'New password must contain: 8 characters minimum, one lowercase character, one uppercase character, one number',
    )
    .test(
      'is-password-valid',
      'New password must contain: 8 characters minimum, one lowercase character, one uppercase character, one number',
      (password: string) => {
        if (!/[A-Z]/.test(password)) {
          return false
        }
        if (!/[a-z]/.test(password)) {
          return false
        }
        if (!/\d/.test(password)) {
          return false
        }
        return true
      },
    ),
  passwordconfirmation: Yup.string()
    .required('Password is required')
    .oneOf([Yup.ref('password')], 'Password does not match'),
})

interface Props {
  handleResetTemporaryPassword: (password: string) => Promise<any>
}

export const ResetTemporaryPassword: React.FunctionComponent<Props> = props => {
  const resetTemporaryPasswordInitialValues: ResetTemporaryPasswordValues = {
    password: '',
    passwordconfirmation: '',
  }

  const handleSubmit = (values: ResetTemporaryPasswordValues, actions: FormikActions<ResetTemporaryPasswordValues>) => {
    props.handleResetTemporaryPassword(values.password).catch(() => {
      actions.setSubmitting(false)
    })
  }

  return (
    <>
      <div className="panel-heading">You need to reset your password. Please enter a new one</div>
      <div className="panel-body">
        <Formik
          initialValues={resetTemporaryPasswordInitialValues}
          validationSchema={ResetTemporaryPasswordValidationSchema}
          onSubmit={handleSubmit}
          render={({ isValid, isSubmitting }) => (
            <Form>
              <label htmlFor="password" className="control-label">
                New Password
              </label>
              <Field
                type="password"
                name="password"
                id="password"
                className="form-control dw-input"
                required
                title="New Password"
                placeholder="New Password"
              />
              <ErrorMessage name="password" render={errorMessage => <ITSError errorMessage={errorMessage} />} />
              <label htmlFor="passwordconfirmation" className="control-label">
                Confirm Password
              </label>
              <Field
                type="password"
                name="passwordconfirmation"
                id="passwordconfirmation"
                className="form-control dw-input"
                required
                title="Confirm Password"
                placeholder="Confirm Password"
              />
              <ErrorMessage
                name="passwordconfirmation"
                render={errorMessage => <ITSError errorMessage={errorMessage} />}
              />
              {!isSubmitting ? (
                <button type="submit" className="btn btn-default dw-btn" id="login-btn" disabled={!isValid}>
                  Reset Password
                </button>
              ) : (
                <img src={loadingBox} className="loading" alt="loading" />
              )}
            </Form>
          )}
        />
      </div>
    </>
  )
}
